import React, { useEffect, useState } from "react";
import { useContext } from "react";
// import { AppContext } from "../Context";
import { MdOutlineCancelPresentation } from "react-icons/md";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import { GrLinkNext } from "react-icons/gr";
// import { GrLinkPrevious } from "react-icons/gr";
import { GoogleMap, LoadScript, Marker, InfoWindow} from "@react-google-maps/api";
import { AppContext } from "../../Context/Context";

function Maps(props) {
  const {
    mapModal,
    setMapModal,
    activityLogs,
    // setActivityLogs,
    //  map_polygons
  } = useContext(AppContext);

  const [centerCoordinates, setCenterCoordinates] = useState({});
  const [markerInfo, setMarkerInfo] = useState([]);
  const [showMarker, setShowMarker] = useState(false);
  const [selectedMarker, setSelectedMarker] = useState(null); // State to manage selected marker
  const [showAlert, setShowAlert] = useState(false); // State to manage selected marker

  const handleMarkerClick = (marker) => {
    setSelectedMarker(marker); // Set the selected marker
  };
  const mapContainerStyle = {
    height: "347px",
    width: "350px",
  };

  useEffect(() => {
    if (
      activityLogs.length > 0 &&
      activityLogs[0]?.currentLocation?.coordinates?.length > 0
    ) {
      setCenterCoordinates({
        lat: activityLogs[0].currentLocation.coordinates[1],
        lng: activityLogs[0].currentLocation.coordinates[0],
      });
      setShowMarker(true);
      refineData(activityLogs);
    } else {
      if(showAlert){
        alert('No activity log found!');

      }
      setShowMarker(false);
      setShowAlert(true);
    }
  }, [activityLogs]);

  useEffect(()=>{
    if(!activityLogs.length){
    }
  },[]);

  function convertToIST(dateString) {
    const utcDate = new Date(dateString);

    const utcTime = utcDate.getTime();

    const istOffset = 5.5 * 60 * 60 * 1000;

    const istDate = new Date(utcTime + istOffset);

    return istDate.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  function refineData(alllogs) {
    alllogs.map((el, i) =>
      el.activity.map((activity, index) => {
        setMarkerInfo((prev) => [
          ...prev,
          {
            state: activity.state,
            district: activity.district,
            sub_dist: activity.sub_dist,
            village: activity.village,
            crop: activity.crop,
            date: activity.date,
            activity_searchedCoordinates_longitude:
              activity.searchedCoordinates.longitude,
            activity_searchedCoordinates_latitude:
              activity.searchedCoordinates.latitude,
            currentLocation_logitude: el.currentLocation.coordinates[0],
            currentLocation_latitude: el.currentLocation.coordinates[1],
          },
        ]);
      })
    );
  }

  return (
    <div
      className={`fixed${
        !activityLogs.length > 0 ? "top-1/2 left1/2" : " bottom-0 left-0 w-full"
      }   flex justify-end`}
    >
      {mapModal && (
        <div className=" p-6 rounded-lg overflow-hidden bg-gray-400 bg-opacity-20 backdrop-blur-sm relative  ">
          <span
            className="absolute -top-0 right-0.5 "
            onClick={() => setMapModal(false)}
          >
            <MdOutlineCancelPresentation size={24} />
          </span>
          {!activityLogs.length  ? (
            
            <div className="w-screen">No Activity yet...</div>
          ) : (
            <div className="flex justify-center items-center gap-2">
              <div>
                <TableContainer sx={{ height: "350px" }} component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">
                          {<span className="text-xs">SNo</span>}
                        </TableCell>
                        <TableCell align="center">
                          {<span className="text-xs">Name</span>}
                        </TableCell>
                        <TableCell align="center">
                          {<span className="text-xs">Activity</span>}
                        </TableCell>
                        <TableCell align="center">
                          {<span className="text-xs">Email</span>}
                        </TableCell>
                        <TableCell align="center">
                          {<span className="text-xs">Status</span>}
                        </TableCell>
                        <TableCell align="center">
                          {<span className="text-xs">State</span>}
                        </TableCell>
                        <TableCell align="center">
                          {<span className="text-xs">District</span>}
                        </TableCell>
                        <TableCell align="center">
                          {<span className="text-xs">Date& Time</span>}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {activityLogs?.map((row, i) => (
                        <TableRow
                          key={i + 1}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            // fontSize: '12px',
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {<span className="text-xs">{i + 1}</span>}
                          </TableCell>
                          <TableCell align="left">
                            {
                              <span className="text-xs">
                                {row.userDetail.userName}
                              </span>
                            }
                          </TableCell>
                          <TableCell align="left">
                            {<span className="text-xs">{"login"}</span>}
                          </TableCell>
                          <TableCell align="left">
                            {
                              <span className="text-xs">
                                {row.userDetail.email}
                              </span>
                            }
                          </TableCell>
                          <TableCell align="left">
                            {row.userDetail.status === "Active" ? (
                              <span className="text-green-900 font-bold">
                                Active
                              </span>
                            ) : (
                              <span className="text-red-700 font-bold">
                                Deactive
                              </span>
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {
                              <span className="text-xs">
                                {row.activity.length > 0
                                  ? row.activity[0].state
                                  : "na"}
                              </span>
                            }
                          </TableCell>
                          <TableCell align="left">
                            {
                              <span className="text-xs">
                                {row.activity.length > 0
                                  ? row.activity[0].district
                                  : "na"}
                              </span>
                            }
                          </TableCell>
                          <TableCell align="left">
                            {" "}
                            {
                              <span className="text-xs">
                                {convertToIST(
                                  row.login_date.replace("T", "\n")
                                )}
                              </span>
                            }
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

              <div className="">
                {showMarker && (
                  <LoadScript googleMapsApiKey="AIzaSyC2dRoGDWlSecHeW-fYaq3YuYxeOEsP90Y">
                    <GoogleMap
                      mapContainerStyle={mapContainerStyle}
                      center={{
                        lat: centerCoordinates.lat,
                        lng: centerCoordinates.lng,
                      }}
                      zoom={10}
                      mapTypeId="satellite"
                    >
                      {markerInfo?.map((el, i) => (
                        <Marker
                          key={i}
                          position={{
                            lat: el.activity_searchedCoordinates_latitude,
                            lng: el.activity_searchedCoordinates_longitude,
                          }}
                          onClick={() => handleMarkerClick(el)}
                        />
                      ))}
                      {/* InfoWindow to display information */}
                      {selectedMarker && (
                        <InfoWindow
                          position={{
                            lat: selectedMarker.activity_searchedCoordinates_latitude,
                            lng: selectedMarker.activity_searchedCoordinates_longitude,
                          }}
                          onCloseClick={() => setSelectedMarker(null)} // Close the InfoWindow
                        >
                          <div className="text-xs ">
                            <p>State: {selectedMarker.state}</p>{" "}
                            <p>District: {selectedMarker.district}</p>{" "}
                            <p>Sub_dist: {selectedMarker.sub_dist}</p>{" "}
                            <p>Village: {selectedMarker.village}</p>{" "}
                            <p>Crop: {selectedMarker.crop}</p>{" "}
                            <p>Date: {selectedMarker.date}</p>{" "}
                          </div>
                        </InfoWindow>
                      )}
                    </GoogleMap>
                  </LoadScript>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Maps;
